import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_452: DocMigration = {
  maxSchemaVersion: "0.0.452",
  description: "Removes isDefault field from doc elevations",
  apply(json: any) {
    for (const id in json.elevations) {
      const elevation = json.elevations[id];
      delete elevation.isDefault;
    }

    return json;
  },
};

export default migration_0_0_452;
